import type { FunctionComponent } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import NarratorDialog from '../../components/organisms/NarratorDialog';
import { Next } from '../../components/molecules/Dialog';
import { IS_DEBUG } from '../../utils/debug';

export interface Props {
	onClose: () => void;
	onNext: () => void;
}

const WhyIntroScreen: FunctionComponent<Props> = (props: Props) => {
	const { onClose, onNext } = props;
	const { t } = useTranslation();

	return (
		<NarratorDialog
			onClose={IS_DEBUG ? onClose : undefined}
			text={t('introduction.why.description', { returnObjects: true })}
		>
			<Next onClick={onNext}>
				<Trans>introduction.why.next</Trans>
			</Next>
		</NarratorDialog>
	);
};

export default WhyIntroScreen;
